import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { routes } from "../constants/Routes";

export function MobileOverlay() {
  const location = useLocation();
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (location.pathname === routes.help) {
      setShow(false);
    } else {
      setShow(true);
    }
  }, [location]);

  if (!show) {
    return null;
  }

  return (
    <div className="display-mobile">
      This application was not build for mobile devices as we believe that this
      exercise is of utmost importance.
    </div>
  );
}
